import monolithic from "fela-monolithic"

export default {
  plugins: [],
  enhancers: [monolithic({ prettySelectors: true })],
  devMode: process.env.NODE_ENV !== "production",
}
